import { render } from "./CreateIsolatedNetworkForm.vue?vue&type=template&id=28a57c86&scoped=true"
import script from "./CreateIsolatedNetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateIsolatedNetworkForm.vue?vue&type=script&lang=js"

import "./CreateIsolatedNetworkForm.vue?vue&type=style&index=0&id=28a57c86&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a57c86"]])

export default __exports__